





































































































































import { Component, Prop, PropSync, Ref, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import {
  BibliographyClass,
  BibliographyFullId,
  CollectionFlag,
  Prefix,
  SortOrder
} from '@/types'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'
import InputCode from '@/components/molecules/InputCode/InputCode.vue'
import { SystemCode, systemCodeApi, SystemCodeWithKey } from '@/api'
import { CODE_KEY } from '@/config'
import { Emit } from '@/node_modules/nuxt-property-decorator'
import { orderBy } from 'lodash'
import ButtonToggle from '@/components/molecules/ButtonToggle/ButtonToggle.vue'
import { IButtonToggleItem } from '@/components/molecules/ButtonToggle/ButtonToggle.type'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'

const COLS: Col[] = [
  {
    width: 40,
    items: [
      {
        name: 'descNo',
        align: 'right'
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    items: [
      {
        name: 'sortTitle',
        headerText: 'タイトル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'collectionNo',
        headerText: '資料番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '17',
    resizable: true,
    items: [
      {
        name: 'sortAuthor',
        headerText: '責任表示／年月日号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'holdingBranchCode',
        headerText: '所蔵館'
      }
    ]
  },
  {
    width: '16',
    resizable: true,
    items: [
      {
        name: 'shelfType',
        headerText: '配架'
      }
    ]
  },
  {
    width: '14',
    resizable: true,
    items: [
      {
        name: 'collectionType',
        headerText: '資料区分'
      }
    ]
  },
  {
    width: '14',
    resizable: true,
    items: [
      {
        name: 'handlingType',
        headerText: '取扱'
      }
    ]
  },
  {
    width: 70,
    items: [
      {
        name: 'cancel',
        headerText: '',
        align: 'center'
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        headerText: '',
        align: 'center'
      }
    ]
  }
]

export interface BookbindingCollectionTableInputItem {
  collectionId: number
  collectionNo: string
  parentCollectionId: number | null
  holdingBranchCode: {
    input: string
    errorMessage: string
  }
  shelfType: SystemCode
  collectionType: {
    input: string
    errorMessage: string
  }
  handlingType: {
    input: string
    errorMessage: string
  }
  revision: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  displayTitle: string
  sortTitle: string
  displayAuthor: string
  sortAuthor: string
  displayPublisher: string
  collectionFlag: CollectionFlag
  _remove: {
    input: boolean
  }
}

export interface BookbindingCollectionTableItem {
  collectionNo: {
    input: string
    errorMessage: string
  }
  collections: BookbindingCollectionTableInputItem[]
}

export const defaultBookbindingCollectionTableItem = (): BookbindingCollectionTableItem => ({
  collectionNo: {
    input: '',
    errorMessage: ''
  },
  collections: []
})

@Component({
  components: {
    InputCollectionNo,
    ButtonToggle,
    InputCode,
    IconBibliography,
    DataTable
  }
})
export default class BookbindingCollectionTable extends ComponentVue {
  @Ref()
  inputCollectionNo!: InputCollectionNo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @PropSync('item', {
    type: Object,
    required: true
  })
  tableItem!: BookbindingCollectionTableItem

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return COLS
  }

  get toggleItems(): IButtonToggleItem[] {
    return [
      {
        value: true,
        text: '解除'
      }
    ]
  }

  get libraryBranchSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.LIBRARY_BRANCH.KEY)
  }

  get shelfTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.SHELF_TYPE.KEY)
  }

  get collectionTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.COLLECTION_TYPE.KEY)
  }

  get handlingTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.HANDLING_TYPE.KEY)
  }

  get reverseCollections(): BookbindingCollectionTableInputItem[] {
    return [...this.tableItem.collections].reverse()
  }

  get sortedCollections(): BookbindingCollectionTableInputItem[] {
    if (this.sortName) {
      return orderBy<BookbindingCollectionTableInputItem>(
        this.reverseCollections,
        (item: BookbindingCollectionTableInputItem) => {
          const propertyValue =
            item[this.sortName as keyof BookbindingCollectionTableInputItem]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.reverseCollections
  }

  @Watch('tableItem.collections')
  onChangeCollections(): void {
    this.onSort({
      name: this.sortName,
      order: this.sortOrder
    })
  }

  mounted(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  focusCollectionNo(): void {
    this.inputCollectionNo.focus()
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  onSort(sortColumn: SortColumn): void {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  onClickRemove(index: number): void {
    const targetIndex: number = this.tableItem.collections.findIndex(
      collection =>
        collection.collectionId === this.sortedCollections[index].collectionId
    )

    this.tableItem.collections.splice(targetIndex, 1)
  }

  @Emit('title')
  onClickTitle(value: BibliographyFullId): BibliographyFullId {
    return value
  }

  @Emit('search')
  onClickSearch(): void {}

  @Emit('determine:collection-no')
  onDetermineCollectionNo(): void {}
}
